import { createFileRoute } from '@tanstack/react-router'
import { Select, Trans, useLingui } from '@lingui/react/macro'
import { AddSelfExclusionRequestType } from '@/features/self-exclusion/types'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { AccessControlConfirmation } from '../-confirmation/access-control-confirmation'

const searchSchema = z.object({
  validTo: z.string().datetime(),
  type: z.enum([
    'HALF_YEAR',
    'YEAR',
    'INDEFINITE',
    'TEST_20_SEC',
    'TEST_5_MIN',
  ]),
})

export const Route = createFileRoute(
  '/_app/your-play/access-controls/self-exclusion-confirmation',
)({
  component: SelfExclusionConfirmation,
  validateSearch: zodValidator(searchSchema),
})

function SelfExclusionConfirmation() {
  const { i18n } = useLingui()
  const search = Route.useSearch()
  const date = i18n.date(search.validTo, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })

  return (
    <AccessControlConfirmation
      heading={<Trans>You have successfully set a Self-exclusion</Trans>}
      description={
        <>
          {search.type === 'INDEFINITE' ? (
            <Trans>Your indefinite Self-exclusion has started.</Trans>
          ) : (
            <Trans>
              Your{' '}
              <Select
                value={search.type as AddSelfExclusionRequestType}
                _HALF_YEAR="6 months"
                _YEAR="1 year"
                other=""
              />{' '}
              Self-exclusion has started and will end on {date}
            </Trans>
          )}
        </>
      }
    />
  )
}
